import React, { useState } from 'react';
import { Button } from '@mui/material';
import history from 'services/history';
import Appbar from 'components/appbar/Appbar';
import PageHeaderActions from 'components/page-header/PageHeaderActions';
import NewRecordAction from 'components/page-header/NewRecordAction';
import NewRecordButton from 'components/page-header/NewRecordButton';
import { usePermissionRules } from 'hooks/permissionRules';
import SurgerieClosedFilterBox from './SurgerieClosedFilterBox';
import { SurgerieProvider } from './hooks/useSurgerie';
import { useFetchSurgeries } from './hooks/useFetchSurgeries';
import TableLoading from 'components/loading/TableLoading';
import { useDisplayMode } from 'hooks/useDisplayMode';
import ModuleLoading from 'components/loading/ModuleLoading';
import PaginationProvider from 'hooks/pagination';
import NoData from 'components/no-data/NoData';
import SurgerieClosedListTable from './list/table/SurgerieClosedListTable';
import SurgerieClosedListModule from './list/module/SurgerieClosedListModule';
import Pagination from 'components/pagination/Pagination';

const SurgerieClosed: React.FC = () => {
  const {
    filter,
    handleChangeFilter,
    handleSearch,
    loading,
    setSelectedSurgerie,
    surgeries,
    handleSort,
    page,
    rows,
    total,
    setPage,
    setRows,
    selectedSurgerie,
  } = useFetchSurgeries();
  const [displayMode] = useDisplayMode();
  const canCreate = usePermissionRules().checkPermission('surgeries.new');
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  function onExited() {
    setSelectedSurgerie(null);
    setAnchorEl(null);
  }

  return (
    <SurgerieProvider
      value={{
        anchorEl,
        setAnchorEl,
        filter,
        handleChangeFilter,
        handleSearch,
        loading,
        selectedSurgerie,
        setSelectedSurgerie,
      }}
    >
      <Appbar
        title="Orçamentos cirúrgicos - Fechados"
        ActionsComponent={canCreate ? <NewRecordAction to="/surgeries/new" /> : undefined}
      />
      <PageHeaderActions
        title="Orçamentos cirúrgicos - Fechados"
        description="Visualize e gerencie os orçamentos cirúrgicos fechados."
        ActionComponent={
          canCreate ? (
            <div style={{ display: 'flex', gap: 8 }}>
              <Button variant="outlined" color="inherit" onClick={() => history.push('/surgeries/import')}>
                Importar planilha
              </Button>
              <NewRecordButton label="Novo orçamento" to="/surgeries/new" />
            </div>
          ) : undefined
        }
      />

      <SurgerieClosedFilterBox />

      {loading ? (
        displayMode === 'list' ? (
          <TableLoading />
        ) : (
          <ModuleLoading />
        )
      ) : surgeries.length === 0 ? (
        <NoData message="Nenhum orçamento fechado" />
      ) : (
        <PaginationProvider rowsPerPage={rows}>
          {displayMode === 'list' ? (
            <SurgerieClosedListTable surgeries={surgeries} />
          ) : (
            <SurgerieClosedListModule surgeries={surgeries} />
          )}

          <Pagination
            count={total}
            currentPage={page}
            currentRowsPerPage={rows}
            onChangePage={page => setPage(page)}
            onChangeRowsPerPage={rows => setRows(rows)}
          />
        </PaginationProvider>
      )}
    </SurgerieProvider>
  );
};

export default SurgerieClosed;
